/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as angular from 'angular';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
let anyWindow: any = window;

angular.module('CanvasWrapper').factory('InteractionPan', PanFactory);
/**
 * @namespace Pan
 * @returns {CanvasWrapper.Interaction.Pan}
 * @memberOf CanvasWrapper.Interaction
 * @constructor
 */
PanFactory.$inject = ['InteractionHandleEvent'];
function PanFactory(InteractionHandleEvent) {
	let handleEvent = InteractionHandleEvent;
	function Pan(displayNode, inertia) {
		function mouseDown(e) {
			start(e.data.originalEvent);
		}

		function touchStart(e) {
			start(e.data.originalEvent.targetTouches[0]);
		}

		function start(t) {
			if (displayNode._pan) {
				if (!displayNode._pan.intervalId) {
					return;
				}
				clearInterval(displayNode._pan.intervalId);
				handleEvent(displayNode).emit('panend');
			}
			displayNode._pan = {
				p: {
					x: t.clientX,
					y: t.clientY,
					date: new Date(),
				},
			};
			handleEvent(displayNode).on('mousemove', mouseMove);
			handleEvent(displayNode).on('touchmove', touchMove);
		}

		function mouseMove(e) {
			move(e, e.data.originalEvent);
		}

		function touchMove(e) {
			let t = e.data.originalEvent.targetTouches;
			if (!t || t.length > 1) {
				end(e, t[0]);
				return;
			}
			move(e, t[0]);
		}

		function move(e, t) {
			let now: any = new Date();
			let interval = now - displayNode._pan.p.date;
			if (interval < 12) {
				return;
			}
			let dx = t.clientX - displayNode._pan.p.x;
			let dy = t.clientY - displayNode._pan.p.y;
			let distance = Math.sqrt(dx * dx + dy * dy);
			if (!displayNode._pan.pp) {
				let threshold = t instanceof anyWindow.MouseEvent ? 2 : 7;
				if (distance > threshold) {
					handleEvent(displayNode).emit('panstart');
				} else {
					return;
				}
			} else {
				let event = {
					deltaX: dx,
					deltaY: dy,
					velocity: distance / interval,
					data: e.data,
				};
				handleEvent(displayNode).emit('panmove', event);
			}
			displayNode._pan.pp = {
				x: displayNode._pan.p.x,
				y: displayNode._pan.p.y,
				date: displayNode._pan.p.date,
			};
			displayNode._pan.p = {
				x: t.clientX,
				y: t.clientY,
				date: now,
			};
		}

		function mouseUp(e) {
			end(e, e.data.originalEvent);
		}

		function touchEnd(e) {
			if (e && e.data.originalEvent.changedTouches && e.data.originalEvent.changedTouches.length > 0) {
				end(e, e.data.originalEvent.changedTouches[0]);
			}
		}

		function end(e, t) {
			handleEvent(displayNode).removeListener('mousemove', mouseMove);
			handleEvent(displayNode).removeListener('touchmove', touchMove);
			if (!displayNode._pan || !displayNode._pan.pp) {
				displayNode._pan = null;
				return;
			}
			if (inertia) {
				if (displayNode._pan.intervalId) {
					return;
				}
				let interval = (new Date() as any) - displayNode._pan.pp.date;
				let vx = (t.clientX - displayNode._pan.pp.x) / interval;
				let vy = (t.clientY - displayNode._pan.pp.y) / interval;
				displayNode._pan.intervalId = setInterval(function () {
					if (Math.abs(vx) < 0.04 && Math.abs(vy) < 0.04) {
						clearInterval(displayNode._pan.intervalId);
						handleEvent(displayNode).emit('panend');
						displayNode._pan = null;
						return;
					}
					let touch = {
						clientX: displayNode._pan.p.x + vx * 12,
						clientY: displayNode._pan.p.y + vy * 12,
					};
					move(e, touch);
					vx *= 0.9;
					vy *= 0.9;
				}, 12);
			} else {
				handleEvent(displayNode).emit('panend');
				displayNode._pan = null;
			}
		}

		displayNode.eventMode = EventMode.Static;
		handleEvent(displayNode).on('mousedown', mouseDown);
		handleEvent(displayNode).on('touchstart', touchStart);
		handleEvent(displayNode).on('mouseup', mouseUp);
		handleEvent(displayNode).on('mouseupoutside', mouseUp);
		handleEvent(displayNode).on('touchend', touchEnd);
		handleEvent(displayNode).on('touchendoutside', touchEnd);

		return handleEvent(displayNode);
	}

	return Pan;
}
